// T178 "Select Your Team" options: the requester's department teams first, then every other
// ACTIVE team (any requester may raise an approved use case for any active team; the per-user
// department rule still decides which target users can be added). Pure (node-testable).

export const teamSlug = (label) => String(label || '').toLowerCase().replace(/\s+/g, '_');
const norm = (s) => String(s || '').toLowerCase().trim();

const activeTeams = (teams) => (teams || []).filter(t => t && t.active === true && t.teamLabel);

// Teams whose orgName or orgAliases equal the requester's department (exact, case-insensitive, trimmed).
export function teamsForDepartment(teams, userDepartment) {
    if (!userDepartment) return [];
    const dept = norm(userDepartment);
    return activeTeams(teams).filter(team =>
        (team.orgAliases || []).map(norm).includes(dept) || norm(team.orgName) === dept);
}

// Non-empty option groups, in display order. Unknown department -> one group with every active team.
export function teamSelectGroups(teams, userDepartment) {
    const matching = teamsForDepartment(teams, userDepartment);
    const others = activeTeams(teams).filter(t => !matching.includes(t));
    const groups = [];
    if (matching.length > 0) groups.push({ label: 'Teams for your department', teams: matching });
    if (others.length > 0) groups.push({ label: matching.length > 0 ? 'Other approved teams' : 'Approved teams', teams: others });
    return groups;
}

// The team config behind a dropdown value (slug of teamLabel), or undefined.
export const findTeamBySlug = (groups, value) =>
    (groups || []).flatMap(g => g.teams).find(t => teamSlug(t.teamLabel) === value);
